import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss'],
  standalone: false,
})
export class TermsAndConditionsComponent implements OnInit {
  // Public/private properties.
  public scrolling = true;

  constructor(
    private router: Router,
    private titleService: Title,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}

  /**
   *
   */
  ngOnInit(): void {
    this.titleService.setTitle('Breello');
  }

  /**
   * Prevents scrolling when sliding menu is open.
   */
  public updateScrolling(): void {
    this.scrolling = !this.scrolling;
    if (
      isPlatformBrowser(this.platformId) &&
      typeof window !== 'undefined' &&
      (window as any).$
    ) {
      if (!this.scrolling) {
        (window as any).$('body').css('overflow', 'hidden');
      } else {
        (window as any).$('body').css('overflow', 'auto');
      }
    }
  }

  /**
   * Navigates user to contact page.
   */
  public navigateToContact(): void {
    this.router.navigate(['/contact']);
    if (isPlatformBrowser(this.platformId)) {
      window.scroll(0, 0); // reset the scroll position to the top left of the document.
    }
  }
}
